import { render, staticRenderFns } from "./unloadShipDetail.vue?vue&type=template&id=037dd5bf&"
import script from "./unloadShipDetail.vue?vue&type=script&lang=js&"
export * from "./unloadShipDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports